import $ from "jquery";

export default class NewsList {
  static init() {
    NewsList.initPager();
  }

  private static initPager() {
    const $newsList = $(".nt-news-list");

    $newsList.on("click", ".js-change-page", (e) => {
      e.preventDefault();

      const newIx = $(e.currentTarget).data("ix");
      const pageIndexRegex = /(pageindex=)[^\&]+/;

      let redirectUrl = window.location.href;

      if (redirectUrl.match(pageIndexRegex)) {
        redirectUrl = redirectUrl.replace(pageIndexRegex, "$1" + newIx);
      } else {
        const separator = redirectUrl.indexOf("?") !== -1 ? "&" : "?";
        redirectUrl = `${redirectUrl}${separator}pageindex=${newIx}`;
      }

      window.location.href = redirectUrl;
    });
  }
}
